<template>
  <div class="pack-list-item-header">
    <router-link :to="packListItemHeaderLinkTo" class="link">
      <div class="title">{{ item.title }}</div>
      <div class="meta"># {{ item.packIndex + 1 }}</div>
    </router-link>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PackListItemHeader',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    packListItemHeaderLinkTo() {
      return {
        name: 'postShow',
        params: {
          postId: this.item.firstNode,
        },
      };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/pack-list-item-header.css';
</style>
